import { ApiGateWay } from '../../../ApiGateWay/ApiGateWay';
import { Config } from '../../../config/config';
import Cookie from 'js-cookie';

const config = JSON.parse(Config);

export const LOGISTICS_STORE_NONCONFORMITIES = async (
  url,
  storeId,
  month,
  year
) => {
  const fetchedData = await ApiGateWay.Get(
    config['api'] +
      url +
      '?storeId=' +
      storeId +
      '&month=' +
      month +
      '&year=' +
      year
  )
    .then((response) => response.json())
    .then((response) => {
      if (
        response.errorMessage === 'Token Expired' ||
        response.errorMessage === 'Invalid Token:::JWT expired' ||
        response.errorMessage ===
          'Your session has expired. Please login again.'
      ) {
        Cookie.remove('currentUser');
        Cookie.remove('stores');
        Cookie.remove('storesAll');
        Cookie.remove('warehouses');

        localStorage.clear();
        sessionStorage.clear();
        alert('Your session has expired. Please login again.');
        return (window.location = '/');
      }
      let body = [];
      let stores = [];
      let colorCodes = [];
      let NCPointsClosed = [];
      let NCPointsOpen = [];
      let body_NC_all = [];
      let stores_NC_all = [];
      let colorCodes_NC_all = [];
      let graphData = [];
      let totalCloseCount = [];
      let totalCount = [];
      let proxyjson = [];

      response.nonConfirmityOpenCloseStoreWiseDashBoards.map((name, val) => {
        stores.push(name.monthName);
        body.push([name.openCount.toString(), name.closeCount.toString()]);
        NCPointsOpen.push(name.openCount);
        NCPointsClosed.push(name.closeCount);
        colorCodes.push([0, 0]);
      });

      response.nonConfirmityAllStoreWiseDashBoards.map((name, val) => {
        stores_NC_all.push(name.monthName);
        colorCodes_NC_all.push([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
        body_NC_all.push([
          name.dailyCloseCount == null ? '0' : name.dailyCloseCount.toString(),
          name.dailyCount == null ? '0' : name.dailyCount.toString(),
          name.weeklyCloseCount == null
            ? '0'
            : name.weeklyCloseCount.toString(),
          name.weeklyCount == null ? '0' : name.weeklyCount.toString(),
          name.sodCloseCount == null ? '0' : name.sodCloseCount.toString(),
          name.sodCount == null ? '0' : name.sodCount.toString(),
          name.flowsCloseCount == null ? '0' : name.flowsCloseCount.toString(),
          name.flowsCount == null ? '0' : name.flowsCount.toString(),
          name.bsuCloseCount == null ? '0' : name.bsuCloseCount.toString(),
          name.bsuCount == null ? '0' : name.bsuCount.toString(),
          name.additionalCloseCount == null
            ? '0'
            : name.additionalCloseCount.toString(),
          name.additionalCount == null ? '0' : name.additionalCount.toString(),
          name.totalCloseCount == null ? '' : name.totalCloseCount.toString(),
          name.totalCount == null ? '' : name.totalCount.toString(),
        ]);
        totalCloseCount.push(name.totalCloseCount);
        totalCount.push(name.totalCount);
        graphData.push([
          name.dailyCount == null ? '0' : name.dailyCount.toString(),
          name.weeklyCount == null ? '0' : name.weeklyCount.toString(),
          name.sodCount == null ? '0' : name.sodCount.toString(),
          name.flowsCount == null ? '0' : name.flowsCount.toString(),
          name.bsuCount == null ? '0' : name.bsuCount.toString(),
          name.additionalCount == null ? '0' : name.additionalCount.toString(),
        ]);
      });

      return (proxyjson = {
        proxyjson: {
          type: 'Nonconformities',
          thead: ['Month', 'Points Open', 'Points Closed'],
          evacuationCount: [0, 0, 0, 0, 0],
          tbody: body,
          columns: ['Month', 'Points Open', 'Points Closed'],
          stores: stores,
          colorCodes: colorCodes,
          popUpDataGrid: body,
          popUpDataGridHeaders: [
            'Description',

            'Due Date',
            'Created Date',
            'Created By',
            'Assigned To',
            'Source',
          ],
          pointsOpen: NCPointsClosed,
          pointsClosed: NCPointsOpen,
        },

        proxyJsonWeeklyCheckList: {
          type: 'Nonconformities',
          thead: [
            'Month',
            'Daily Count',
            '',
            'Weekly Count',
            '',
            'SOD Count',
            '',
            'Flows Count',
            '',
            'BSU Count',
            '',
            'Additional Count',
            '',
            'Total',
            '',
          ],
          dhead: [
            'Month',
            'Daily Count',
            'Weekly Count',
            'SOD Count',
            'Flows Count',
            'BSU Count',
            'Additional Count',
          ],
          head: [
            'Month',
            'Daily Count',
            'Daily Count',
            'Weekly Count',
            'Weekly Count',
            'SOD Count',
            'SOD Count',
            'Flows Count',
            'Flows Count',
            'BSU Count',
            'BSU Count',
            'Additional Count',
            'Additional Count',
            'Total',
            'Total',
          ],
          tbody: body_NC_all,
          columns: [
            '',
            'Close',
            'Open',
            'Close',
            'Open',
            'Close',
            'Open',
            'Close',
            'Open',
            'Close',
            'Open',
            'Close',
            'Open',
            'Close',
            'Open',
          ],
          stores: stores_NC_all,
          colorCodes: colorCodes_NC_all,
          popUpDataGrid: body_NC_all,
          popUpDataGridHeaders: [
            'Description',

            'Due Date',
            'Created Date',
            'Created By',
            'Assigned To',
            'Source',
            'Status',
            'Comments',
          ],
          graphData: graphData,
          totalCloseCount: totalCloseCount,
          totalOpenCount: totalCount,
          storeType: 1,
        },
      });
    });
  return fetchedData;
};
